module.exports = __webpack_public_path__ + "img/plug-type-2.81ca0fa7.png";